import React from 'react';
import { withRouter } from 'react-router-dom';
import BaseContent from 'components/BaseContent';
import Table from 'components/Table';
import {getAppkeys} from 'actions/appkey';
import {PERMISSION_TEXT } from './const';

import style from './index.less';

class Appkey extends React.Component {
    state = {
        list: []
    };
    columns = [{
        title: 'App name',
        dataIndex: 'name',
        key: 'name'
    },{
        title: 'Appkey',
        dataIndex: 'api_key',
        key: 'api_key'
    },{
        title: 'API permissions',
        dataIndex: 'permission',
        key: 'permission',
        render: (text)=> {
            let permissions = [];
            for (const key in text) {
                if (text.hasOwnProperty(key)) {
                    const element = text[key];
                    permissions = permissions.concat(element);

                }
            }
            const permissionText = [];
            permissions.forEach((e,i)=> {
                if (PERMISSION_TEXT[e]) {
                    permissionText.push(<div key={i}>{PERMISSION_TEXT[e]}</div>);
                }
            });
            return permissionText;
        }
    },{
        title: 'QPS',
        dataIndex: 'concurrency',
        key: 'concurrency'
    },{
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (text)=> {
            return text === 0 ? 'Formal' : 'Test';
        }
    },{
        title: 'Operation',
        dataIndex: 'operation',
        key: 'operation',
        render: (text, record)=> {
            return <a onClick={()=> this.props.history.push(`/pages/app/appkey/view/${record.id}`)}>check</a>;
        }
    },];

    onStart = (tableParams,filters) => {
        tableParams = tableParams || {};
        let _params = { ...tableParams };
        if(filters && filters.status){
            _params.status = filters.status;
        }
        if(this.filterParams){
            _params = {..._params,...this.filterParams};
        }

        return getAppkeys(_params).then(e => {
            this.setState({ list: e.data ? e.data : [], total: e.data.length });
        });
    }
    componentDidMount() {
        this.table.change(1);
    }

    render() {
        return (
            <div className={style.appkey}>
                <div className={style.tips}>If you want to bound to a new AppKey, please contact us.</div>
                <BaseContent style={{marginTop: 0}}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.list}
                        onSubmit={this.onStart}
                        total={this.state.total}
                        ref={ref => this.table = ref}
                    />
                </BaseContent>
            </div>
        );
    }
}

export default withRouter(Appkey);



// WEBPACK FOOTER //
// ./src/pages/Appkey/index.js